import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { styled, lighten, darken} from '@mui/system'
import { useEffect, useMemo, useCallback } from 'react'

const AutoCompleteHeader = ({ currentBusiness, businessData, onClick }) => {
  const GroupHeader = styled('div')(({ theme }) => ({
    position: 'sticky',
    top: '-8px',
    padding: '4px 10px',
    color: theme.palette.primary.main,
    backgroundColor:
      theme.palette.mode === 'light'
        ? lighten(theme.palette.primary.light, 0.85)
        : darken(theme.palette.primary.main, 0.8)
  }))

  const options = useMemo(() => {
    if (!businessData?.length) return []

    const seen = new Set()
    const deduped = []

    for (const option of businessData) {
      const key = option?.id ?? option?.organizationId ?? option?.rut ?? option?.name
      if (key == null) {
        deduped.push(option)
        continue
      }
      if (seen.has(key)) continue
      seen.add(key)
      deduped.push(option)
    }

    return deduped.map(option => ({
      ...option,
      name: option.name,
      firstLetter: option.name?.[0]?.toUpperCase()
    }))
  }, [businessData])

  const handleClick = useCallback((newValue) => {
    onClick(newValue || 'ingresa una búsqueda ')
  }, [onClick])

  useEffect(() => {
    if (!businessData?.length || !currentBusiness) return
    const exists = businessData.some(b => Number(b.id) === Number(currentBusiness.id))
    if (!exists) {
      onClick(businessData[0])
    }
  }, [businessData, currentBusiness, onClick])

  return (
    <Autocomplete
      id='grouped-demo'
      options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
      groupBy={option => option.firstLetter}
      getOptionLabel={option => option.name}
      
      // Aquí la clave:
      isOptionEqualToValue={(option, value) => Number(option.id) === Number(value.id)}
      
      value={currentBusiness || null}
      onChange={(_, newValue) => handleClick(newValue)}
      
      className='rounded-full'
      sx={{
        width: { xs: '100%', sm: 250 },
        maxWidth: '100%',
        minWidth: 0,
        fontSize: 11,
        '.MuiOutlinedInput-root': { borderRadius: '9999px', padding: '1px 14px' }
      }}
      
      renderInput={params => (
        <TextField
          {...params}
          size="small"
          sx={{
            '& .MuiInputLabel-root': {
              fontSize: 15,
              
            },
            '& .MuiInputBase-root': {
              height: 30, 
              fontSize: 11 
            }
          }}
          InputProps={{
            ...params.InputProps,
            className: 'rounded-full'
          }}
        />
      )}

      renderOption={(props, option) => {
        const { key, ...optionProps } = props
        const optionKey = option?.id ?? option?.organizationId ?? option?.rut ?? option?.name ?? key
        return (
          <li {...optionProps} key={optionKey}>
            {option.name}
          </li>
        )
      }}
      
      renderGroup={params => (
        <li key={params.key}>
          <GroupHeader sx={{ fontSize: 11 }}>{params.group}</GroupHeader>
          <ul className='p-0 text-xs'>{params.children}</ul>
        </li>
      )}
      
      clearIcon={null}
    />
  )
}

export default AutoCompleteHeader
